import type { AutoLabel, LegalBasis, TriggerType } from '../types/api';

export const TRIGGER_LABELS: Record<TriggerType, string> = {
  'contact.confirmed': 'When a contact joins the newsletter',
  'order.created': 'When an order is created',
  'order.completed': 'When an order is completed',
  'order.first': "On the customer's first completed order",
  'cart.abandoned': 'When a cart is abandoned without a completed purchase',
  'date.birthday': "On the contact's birthday",
  'date.first_order_anniversary': "On the anniversary of the contact's first purchase",
  inactivity: 'When a contact has been inactive',
  'label.entered': 'When the contact is assigned a tag',
  'label.left': 'When the contact loses a tag',
  'browse.abandoned': 'When a known contact looks at a product and does nothing more',
  'checkout.abandoned': 'When a contact starts the checkout and does not pay',
  'product.price_drop': 'When a product a known contact viewed or has in a cart gets cheaper',
  'product.low_stock': 'When a product a known contact viewed or has in a cart is nearly sold out',
};

export const LEGAL_BASIS_LABELS: Record<LegalBasis, string> = {
  optin: 'Marketing consent (opt-in)',
  soft_optin: 'Soft consent (previous customer, no active objection)',
  customer: 'Customer relationship (transactional message, no consent required)',
  none: 'No legal basis required',
};

export const PURPOSE_LABELS: Record<string, string> = {
  service: 'Service',
  marketing: 'Marketing',
  review: 'Review',
  transactional: 'Transactional',
};

export const AUTO_LABEL_NAMES: Record<AutoLabel, string> = {
  new_customer: 'New customer',
  repeat: 'Repeat buyer',
  loyal: 'Loyal customer',
  platinum: 'Platinum',
  vip: 'VIP',
  inactive: 'Inactive',
  lost: 'Lost',
  subscriber_only: 'Subscriber only',
};

export function purposeLabel(purpose: string | undefined): string | undefined {
  if (!purpose) return undefined;
  return PURPOSE_LABELS[purpose] ?? purpose;
}
